var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "current",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130 494 c-12 -4 -15 -19 -12 -79 4 -69 3 -75 -15 -75 -20 0 -63 -34 -63 -50 0 -6 66 -10 166 -10 l166 0 30 -30 c24 -25 28 -35 23 -60 l-7 -30 56 6 c33 4 61 3 68 -3 7 -6 30 -13 50 -17 l37 -7 -19 43 c-10 24 -22 60 -25 81 -8 42 -17 46 -38 17 -12 -18 -16 -18 -33 -5 -10 8 -26 14 -34 14 -10 0 -8 -5 8 -16 15 -11 22 -26 22 -49 0 -29 -4 -34 -22 -34 -21 0 -23 4 -22 60 l1 60 -49 30 c-45 28 -77 32 -63 9 4 -5 -2 -9 -13 -9 -15 0 -21 12 -31 55 -7 30 -10 63 -6 74 4 15 -1 20 -26 25 -34 6 -124 6 -149 0z m40 -64 c0 -29 -4 -40 -15 -40 -11 0 -15 11 -15 40 0 29 4 40 15 40 11 0 15 -11 15 -40z m119 -7 c7 -27 14 -56 17 -65 5 -16 -2 -18 -60 -18 l-66 0 0 65 0 65 49 0 49 0 11 -47z m248 -220 c-3 -10 -5 -4 -5 12 0 17 2 24 5 18 2 -7 2 -21 0 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387 423 c-11 -10 -8 -51 3 -58 6 -4 10 8 10 29 0 37 -2 41 -13 29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 257 c-40 -12 -58 -47 -42 -82 13 -30 -5 -27 197 -29 143 -1 166 1 184 16 11 10 17 18 12 18 -4 0 -2 7 5 15 9 10 9 15 1 15 -6 0 -10 3 -9 8 5 24 -16 39 -53 38 -21 -1 -39 1 -39 4 0 3 -9 6 -20 6 -11 0 -20 -3 -20 -6 0 -3 -16 -5 -35 -5 -19 0 -35 2 -35 5 0 3 -9 6 -20 6 -11 0 -20 -3 -20 -6 0 -8 -63 -7 -70 1 -3 3 -19 1 -36 -4z m31 -37 c4 -6 57 -10 125 -10 68 0 121 4 125 10 9 15 35 12 41 -5 4 -8 1 -22 -6 -30 -11 -14 -15 -14 -36 0 -32 21 -236 22 -254 1 -14 -18 -40 -10 -40 13 0 29 31 44 45 21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 200 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345 200 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle1);
export default __webpack_public_path__ + "static/media/vehicle1.dcfe9b70f1035703a583d09ad5c98d09.svg";
export { ForwardRef as ReactComponent };